import React, { useState } from "react";
import axios from "axios";
import Captcha from "../components/Captcha"; // Import the Captcha component
import API_BASE_URL from "../config";
function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [captchaValue, setCaptchaValue] = useState(""); // Captcha generated value
  const [captchaInput, setCaptchaInput] = useState(""); // Captcha input from user
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    // Validate captcha input
    if (captchaInput !== captchaValue) {
      setError("Captcha input is incorrect.");
      return;
    }

    try {
      const res = await axios.post(
        `${API_BASE_URL}/forgot-password`,
        {
          email,
          captcha: captchaInput, // Send the user input captcha to backend
        }
      );

      if (res.data.success) {
        setMessage("Reset link sent to your email.");
      } else {
        setError(res.data.message || "Failed to send reset link.");
      }
    } catch (err) {
      setError("Error sending request. Please check your email and captcha.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-5 col-12">
          <div className="inbx formbxx">
            <div className="frmtbx">
              <h2 className="mb-2 text-center fw700">Forgot Password</h2>
              <p className="mb-4 text-center pb-3">
                We'll send you reset instructions by email.
              </p>
            </div>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label>Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="row">
                <div className="col-md-5">
                  <Captcha onChange={(val) => setCaptchaValue(val)} />
                </div>
                <div className="col-md-7">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="Enter Captcha"
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)} // Capture user input for captcha
                    />
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-success w-100">
                Send Reset Link
              </button>

              <div className="mt-3 text-center">
                <a className="color1 text-decoration-none" href="/login">
                  Back to <span className="text-success">Login</span>
                </a>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-7 col-12 gx-0">
          <img src="/forg-bg.png" alt="Logo" className="login-bg" />
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
